import { type MouseEvent } from 'react';
import clsx from 'clsx';
import { DropDownIcon } from '../icons';

interface ItemProps {
  className?: string;
  mode: 'item' | 'view';
  index?: number;
  active?: boolean;
  placeholder?: string;
  value?: any;
  onClick?: (e: MouseEvent<HTMLDivElement>, value: any) => void;
}

export const Item = (props: ItemProps) => {
  const displayValue = props.value || props.placeholder;
  const showDropDownIcon = props.mode !== 'item' || props.index === 0;
  const open = props.mode === 'item';
  return (
    <div
      className={clsx([
        'items-center cursor-pointer flex justify-between h-10 pl-4 pr-2 w-full',
        props.className,
        {
          'h-[30px] font-medium': props.mode === 'item',
          'bg-[#4c4c52]/10 font-semibold': props.active,
        },
      ])}
      onClick={(e) => props.onClick?.(e, props.value)}
    >
      <div className='text-[#dadada]'>{displayValue}</div>
      {showDropDownIcon && <DropDownIcon className='h-2 w-3 text-[#4c4c52]' isOpen={open} />}
    </div>
  );
};
